module.exports = __webpack_public_path__ + "static/poetBG-098cb5ffb6a77ecdc45ed943e2c6e91f.png";